import { styled } from '@mui/material'

interface TruncatedTextProps {
  maxwidth?: number | string
  lines?: number
}

const TruncatedText = styled('div', {
  shouldForwardProp: prop => prop !== 'width',
})<TruncatedTextProps>(({ maxwidth, lines = 3 }: TruncatedTextProps) => ({
  maxWidth: maxwidth,
  // height: height,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: lines,
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
}))

export default TruncatedText
